import React, { useState } from 'react';
import rivalTypingIcon from "./icons/rival-typing-icon.svg";
import copyIcon from "./icons/copy.svg";
import { getIconByHelpType, formatText } from "./utils";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import StatsChart from "./components/chart/StatsChart";
import StatsChartPlaceholder from "./components/chart/StatsChartPlaceholder";

const Message = ({
  sender,
  text,
  typing,
  list,
  url,
  defaultQuestions,
  handleSend,
  isLoading,
  helpType,
  review,
  evidence,
  tableData,
  responseSummary,
  isExpanded,
  onRequestExpand,
}) => {
  const isEndUser = sender === "endUser";
  const isRivalAI = sender === "Rival AI";
  const [copied, setCopied] = useState(false);
  const [evidenceExpanded, setEvidenceExpanded] = useState(false);

  const handleCopy = () => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = formatText(text);
    navigator.clipboard.writeText(tempDiv.textContent || tempDiv.innerText);
    setCopied(true);
    setTimeout(() => setCopied(false), 500);
  };

  return (
    <div className={`tw-flex tw-items-start tw-mb-4 ${isEndUser ? "tw-justify-end" : "tw-justify-start"}`}>
      {isRivalAI && (
        <img
          src={getIconByHelpType(helpType)}
          alt="ROSI"
          className="tw-block tw-w-9 tw-h-9 tw-rounded-full tw-border tw-border-gray-300 tw-mr-1"
        />
      )}
      <div className="tw-flex tw-flex-col">
        <div
          className={`tw-ml-1 tw-p-2 tw-rounded-lg tw-break-urls tw-text-sm ${isEndUser
            ? "tw-bg-rivalcharcoal tw-text-white tw-rounded-br-none"
            : "tw-ml-1 tw-bg-rivallightgrey tw-text-rivalsoftblack tw-rounded-tl-none"
            }`}
        >
          {typing ? (
            <img
              src={rivalTypingIcon}
              alt="Typing..."
              className="tw-block tw-animate-spin tw-w-6 tw-h-6"
            />
          ) : (
            <>
              {tableData && (
                isExpanded
                  ? <StatsChart tableData={tableData} responseSummary={responseSummary} />
                  : <StatsChartPlaceholder onClick={onRequestExpand} />
              )}
              {list ? (
                <>
                  <ul className="tw-list-disc tw-list-inside tw-pl-0 tw-my-4 tw-ml-1">
                    {list.map((item, i) => (
                      <li key={i} className="tw-mb-1">{item}</li>
                    ))}
                  </ul>
                  {text && (
                    <div
                      className="tw-mt-2 tw-pt-2 tw-border-solid tw-border-0 tw-border-t tw-border-rivalgrey tw-text-xs tw-text-rivalsoftblack"
                      dangerouslySetInnerHTML={{ __html: formatText(text) }}
                    />
                  )}
                </>
              ) : url ? (
                <a
                  href={text}
                  target="_blank"
                  rel="noreferrer"
                  className="tw-no-underline hover:tw-underline tw-text-berthablue"
                >
                  {text}
                </a>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: formatText(text) }} />
              )}
              {defaultQuestions && (
                <div className="tw-flex tw-flex-col tw-mt-5" style={{ alignItems: 'flex-start', width: '100%' }}>
                  {defaultQuestions.map((question, i) => (
                    <button
                      key={i}
                      onClick={() => handleSend(question)}
                      className="tw-text-sm tw-border tw-border-notblurple tw-text-rivalsoftblack tw-font-normal tw-py-2 tw-px-3 tw-rounded-full tw-mb-3 tw-leading-tight tw-transition tw-ease-in-out tw-duration-200 tw-bg-transparent hover:tw-bg-notblurple-10 focus-visible:tw-outline-rivalsoftblack tw-text-left"
                      style={{ alignSelf: 'flex-start', textAlign: 'left' }}
                      disabled={isLoading}
                    >
                      {question}
                    </button>
                  ))}
                </div>
              )}
              {evidence && (
                <div className="tw-mt-3 tw-mb-2">
                  <button
                    onClick={() => setEvidenceExpanded(!evidenceExpanded)}
                    className="tw-flex tw-items-center tw-font-bold tw-cursor-pointer tw-bg-transparent tw-border-0 tw-p-0 hover:tw-opacity-70 tw-transition-opacity"
                  >
                    Evidence & Sources
                    <ChevronDownIcon 
                      className={`tw-w-5 tw-h-5 tw-ml-2 tw-transition-transform tw-duration-300 ${evidenceExpanded ? 'tw-rotate-180' : ''}`} 
                    />
                  </button>
                  <div 
                    className={`tw-overflow-hidden tw-transition-all tw-duration-500 tw-ease-in-out ${evidenceExpanded ? 'tw-max-h-[1000px] tw-opacity-100' : 'tw-max-h-0 tw-opacity-0'}`}
                  >
                    <span className="tw-block tw-mt-1" dangerouslySetInnerHTML={{ __html: formatText(evidence).replace(/\n/g, '<br>') }} />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {isRivalAI && review && !typing && (
          <div className="tw-relative tw-ml-1 tw-mt-1">
            <img
              src={copyIcon}
              alt="Copy"
              onClick={handleCopy}
              className="tw-w-9 tw-h-9 tw-cursor-pointer hover:tw-opacity-70"
            />
            {copied && (
              <span className="tw-absolute tw-left-10 tw-top-1 tw-bg-rivalcharcoal tw-text-white tw-text-xs tw-px-2 tw-py-1 tw-rounded tw-whitespace-nowrap">
                Copied!
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Message;
